import { render } from "./VAccordionItemPosition.vue?vue&type=template&id=5601b15e&scoped=true"
import script from "./VAccordionItemPosition.vue?vue&type=script&lang=js"
export * from "./VAccordionItemPosition.vue?vue&type=script&lang=js"

import "./VAccordionItemPosition.vue?vue&type=style&index=0&id=5601b15e&scoped=true&lang=css"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5601b15e"]])

export default __exports__